<template>
    <dropzone-submit :delete_route="delete_route" :csrf="csrf">
        <template v-slot:submit-button="{submit}">
            <div class="col-12 col-sm-12 col-md-6 col-lg-6 float-right mt-2 p-0">
                <button class="col-12 float-right btn btn-primary" @click="submit()" :disabled="fileCounter===0"
                        type="submit">
                    {{$lang('Dodaj załączniki')}}
                </button>
            </div>
        </template>
    </dropzone-submit>
</template>

<script>
export default {
    name: "dropzone-submit-blade",
    props: ['delete_route', 'csrf'],
    data() {
        return {
            fileCounter: Number(sessionStorage.getItem('filesCounter'))
        }
    },
    mounted() {
        this.watchStorage();
    },
    methods: {
        watchStorage() {
            setTimeout(() => {
                this.fileCounter = Number(sessionStorage.getItem('filesCounter'))
                this.watchStorage();
            }, 1000)
        }
    }
}
</script>
